import { Seo, faqSchema } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { FaqList } from "@/components/home/Faq";
import { faqs } from "@/data/site";
import { FadeUp } from "@/components/motion/Reveal";
import { CtaBand } from "@/components/home/CtaBand";

export default function FaqPage() {
  return (
    <>
      <Seo title="Häufige Fragen" description="Antworten auf häufige Fragen zu Service, Reparatur, Kostenschätzung und Terminanfrage bei NIVO Garage." schema={faqSchema(faqs)} />
      <PageHeader eyebrow="FAQ" lines={["Häufige", "Fragen."]} />
      <section className="pb-16 md:pb-24">
        <div className="container-x max-w-4xl">
          <FadeUp><FaqList /></FadeUp>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
